import { Slot } from "@radix-ui/react-slot";
import type { ImgHTMLAttributes } from "react";

import { cn } from "../utils/cn";

interface IconVisaProps extends ImgHTMLAttributes<HTMLImageElement> {
  asChild?: boolean;
}

function IconVisa({ className, asChild = false }: IconVisaProps) {
  const Comp = asChild ? Slot : "svg";
  return (
    <Comp
      className={cn(className)}
      fill="none"
      height="38"
      viewBox="0 0 79 38"
      width="79"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect height="38" width="78.5237" />
      <path
        d="M38.9584 9.3593L34.7813 28.7045H29.7295L33.91 9.3593H38.9618H38.9584ZM60.2133 21.8476L62.8714 14.5843L64.4039 21.8476H60.2133ZM65.8516 28.7011H70.5237L66.445 9.35594H62.1323C61.1626 9.35594 60.3455 9.91337 59.9827 10.7764L52.4016 28.7011H57.7077L58.7621 25.8133H65.2447L65.8516 28.7011ZM52.6661 22.3848C52.6864 17.2774 45.5359 16.9987 45.5868 14.7186C45.6003 14.0235 46.2683 13.2881 47.7295 13.0967C48.4551 13.0027 50.4487 12.9322 52.7135 13.9631L53.5985 9.85964C52.3847 9.4231 50.8183 9 48.8721 9C43.878 9 40.3621 11.6293 40.3349 15.3936C40.3044 18.1773 42.8439 19.732 44.7595 20.6588C46.726 21.6058 47.3871 22.2136 47.3803 23.0631C47.3668 24.3627 45.8105 24.9335 44.356 24.957C41.8166 24.9973 40.3417 24.2787 39.1652 23.7347L38.2498 27.9725C39.4297 28.5097 41.6097 28.9765 43.8678 29C49.1739 29 52.6491 26.4009 52.6661 22.3815M31.7367 9.3593L23.5521 28.7045H18.2121L14.1842 13.268C13.9401 12.3177 13.7265 11.9684 12.984 11.5688C11.7702 10.9174 9.76305 10.3029 8 9.92344L8.12206 9.36266H16.7203C17.8154 9.36266 18.802 10.0846 19.0495 11.3338L21.1788 22.5292L26.4374 9.36266H31.7469L31.7367 9.3593Z"
        fill="#1A1F70"
      />
    </Comp>
  );
}

IconVisa.displayName = "IconVisa";

export { IconVisa };
